import { render, staticRenderFns } from "./tasks-modal___1.vue?vue&type=template&id=c9271fd6&scoped=true"
import script from "./tasks-modal___1.vue?vue&type=script&lang=js"
export * from "./tasks-modal___1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9271fd6",
  null
  
)

export default component.exports